import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from './utils';

export class IRoute {
  id: number;
  name: string;
  bill_type: number;
  origin_point: number;
  connected_point: number;
  third_party_point: number;
  length: number | null;
  status: number;
  subroute: number;
  ord: number;
  array: number;
  delivery_time: number | null;
  tolerance: number | null;
  hidden: number;
  last_route: number;
  return_route: number;
}

export class IRouteResponse {
  @Type(() => IRoute)
  result: IRoute;
}

export class IRouteListResponse extends IPagination {
  @Type(() => IRoute)
  results: IRoute[];
}
export class IRouteQueryDto extends IQueryPaginationDto {
  name?: string;
  origin_point?: number;
  connected_point?: string;
  third_party_point?: string;
  bill_type?: string;
  length?: string;
  status?: string;
  action?: string;
  hidden?: number;
  /** newest = id desc (Rotalar listesi); yoksa ada göre */
  sort?: 'newest' | 'name';
}
